import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule } from '../../components/documents/documents-dialog.module';
import { EditServiceLevelsDialogModule } from '../../components/edit-service-levels-dialog/edit-service-levels-dialog.module';
import { ServiceLevelsComponent } from './service-levels.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DocumentsDialogModule,
        EditServiceLevelsDialogModule,
        MatButtonModule,
        MatIconModule,
        MatSlideToggleModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        ServiceLevelsComponent,
    ],
    exports: [
        ServiceLevelsComponent
    ]
})
export class ServiceLevelsModule { }
